// extracted by mini-css-extract-plugin
var _1 = "styles-module__editButton___QOMk1";
export { _1 as "editButton" }
